const compact = new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 });

export const fmtInt = (n: number) => Math.round(n).toLocaleString('en-US');
export const fmtCompact = (n: number) => compact.format(n);
export const fmtCurrency = (n: number) => `$${Math.round(n).toLocaleString('en-US')}`;
export const fmtCurrencyCompact = (n: number) => `$${compact.format(n)}`;
export const fmtPct = (r: number, d = 1) => `${(r * 100).toFixed(d)}%`;
export const fmtSignedPct = (r: number, d = 1) => `${r > 0 ? '+' : ''}${(r * 100).toFixed(d)}%`;
export const fmtPP = (r: number, d = 1) => `${r > 0 ? '+' : ''}${(r * 100).toFixed(d)} pp`;
export const fmtRatio = (n: number, d = 2) => n.toFixed(d);

export function pctChange(cur: number, prev: number | null | undefined): number | null {
  if (prev === null || prev === undefined || prev === 0) return null;
  return (cur - prev) / prev;
}
